// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#footer {
  width: 100%;
  /* height: 240px; */
  background-color: #000078;
  position: relative;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 40px 5%;
}

#footer .info-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}

#footer .info-container .brand-info h4 {
  font-family: 'Cinzel';
  font-size: 22px;
  margin-bottom: 10px;
}

#footer .info-container .brand-info {
  font-size: 12px;
}

#footer .info-container .brand-info a.address {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  cursor: pointer;
}

#footer .info-container .brand-info a.address:hover {
  color: rgba(255, 255, 255, 1);
}

#footer .info-container .brand-info p a {
  color: #ffffff;
  text-decoration: none;
  opacity: 0.6;
}

#footer .info-container .brand-info p a:hover {
  opacity: 1;
}

#footer .info-container .brand-info p span {
  opacity: 0.6;
}

#footer .link-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

#footer a.link {
  text-decoration: none;
  color: #ffffff;
  margin-left: 30px;
  font-size: 15px;
  cursor: pointer;
}

#footer a.link:hover {
  opacity: 0.8;
}


#footer .copy-right {
  font-size: 12px;
  text-align: center;
  position: relative;
}

#footer .copy-right p {
  opacity: 0.6;
}

#footer .copy-right a {
  text-decoration: none;
  color: #ffffff;
  opacity: 0.6;
}

#footer .linkedin{
  position: absolute;
  right: 0;
  top: 0;
  left: auto;
  height: 24px;
  width: 24px;
  z-index: 10;
}
#footer .linkedin a{
  display: block;
}

#footer .telegram{
  position: absolute;
  right: 40px;
  top: 0;
  left: auto;
  height: 24px;
  width: 24px;
  z-index: 10;
}

#footer .copy-right a:hover {
  opacity: 1;
}

@media (max-width: 700px) {
  #footer {
    /* height: 300px; */
  }

  #footer .info-container .brand-info h4,
  #footer .info-container .brand-info p {
    text-align: center;
  }

  #footer .info-container .brand-info {
    margin-bottom: 15px;
  }

  #footer .link-container {
    justify-content: space-around;
    margin-bottom: 15px;
  }

  #footer a.link {
    margin: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./client/styles/Footer.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,UAAU;EACV,YAAY;EACZ,WAAW;EACX,WAAW;AACb;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,UAAU;EACV,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["#footer {\n  width: 100%;\n  /* height: 240px; */\n  background-color: #000078;\n  position: relative;\n  color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  padding: 40px 5%;\n}\n\n#footer .info-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n#footer .info-container .brand-info h4 {\n  font-family: 'Cinzel';\n  font-size: 22px;\n  margin-bottom: 10px;\n}\n\n#footer .info-container .brand-info {\n  font-size: 12px;\n}\n\n#footer .info-container .brand-info a.address {\n  color: rgba(255, 255, 255, 0.6);\n  text-decoration: none;\n  cursor: pointer;\n}\n\n#footer .info-container .brand-info a.address:hover {\n  color: rgba(255, 255, 255, 1);\n}\n\n#footer .info-container .brand-info p a {\n  color: #ffffff;\n  text-decoration: none;\n  opacity: 0.6;\n}\n\n#footer .info-container .brand-info p a:hover {\n  opacity: 1;\n}\n\n#footer .info-container .brand-info p span {\n  opacity: 0.6;\n}\n\n#footer .link-container {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n#footer a.link {\n  text-decoration: none;\n  color: #ffffff;\n  margin-left: 30px;\n  font-size: 15px;\n  cursor: pointer;\n}\n\n#footer a.link:hover {\n  opacity: 0.8;\n}\n\n\n#footer .copy-right {\n  font-size: 12px;\n  text-align: center;\n  position: relative;\n}\n\n#footer .copy-right p {\n  opacity: 0.6;\n}\n\n#footer .copy-right a {\n  text-decoration: none;\n  color: #ffffff;\n  opacity: 0.6;\n}\n\n#footer .linkedin{\n  position: absolute;\n  right: 0;\n  top: 0;\n  left: auto;\n  height: 24px;\n  width: 24px;\n  z-index: 10;\n}\n#footer .linkedin a{\n  display: block;\n}\n\n#footer .telegram{\n  position: absolute;\n  right: 40px;\n  top: 0;\n  left: auto;\n  height: 24px;\n  width: 24px;\n  z-index: 10;\n}\n\n#footer .copy-right a:hover {\n  opacity: 1;\n}\n\n@media (max-width: 700px) {\n  #footer {\n    /* height: 300px; */\n  }\n\n  #footer .info-container .brand-info h4,\n  #footer .info-container .brand-info p {\n    text-align: center;\n  }\n\n  #footer .info-container .brand-info {\n    margin-bottom: 15px;\n  }\n\n  #footer .link-container {\n    justify-content: space-around;\n    margin-bottom: 15px;\n  }\n\n  #footer a.link {\n    margin: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
